import React from 'react';
import '../../../assets/css/StudentShortDetails.css';
import edit from '../../../assets/icons/editnew.svg';
import { formatDateDDMMYYYYHHMMSS } from '../../../Utils/data&dateTime';

export const RemittanceShortDetails = ({ selectedFeeDetails }) => {
    if (!selectedFeeDetails) return null;

    const details = selectedFeeDetails;
    console.log("DETAILS", details);

    return (
        <>
            <div className="col-md-12">


                <div className="col-md-12">
                    <div
                        style={{
                            background: "#7f56da",
                            color: "#ffffff",
                            padding: "12px 16px",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "8px",
                            fontWeight: 600,
                            fontSize: "16px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            {/* Optional Icon */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                                <path d="M10 9H8" />
                                <path d="M16 13H8" />
                                <path d="M16 17H8" />
                            </svg>

                            <span>REMITTANCE&apos;S DETAILS</span>
                        </div>
                    </div>
                </div>

            </div>

            <div
                className="p-3 mt-4 transactionShortdetails"
                style={{
                    border: "1px solid #f0f0f0",
                    borderRadius: "8px",
                    background: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
            >
                <div className='row'>
                    <div className='col-md-6'>
                        <p className="sd-p">Remittance ID</p>
                        <p className="alg-l">{details.remitance_number || 'N/A'}</p>
                    </div>
                    <div className='col-md-6'>
                        <p className="sd-p">Remitter's Name</p>
                        <p className="alg-l">{details.transfered_from?.name || 'N/A'}</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <p className="sd-p">Remittance Date</p>
                        <p className="alg-l">
                            {formatDateDDMMYYYYHHMMSS(details?.created_at)}
                        </p>
                    </div>
                    <div className='col-md-6'>
                        <p className="sd-p">Instrument Type</p>
                        <p className="alg-l">{details.instrument}</p>
                    </div>
                </div>

                <div className='row'>
                    <div className="col-md-6">
                        <p className="sd-p">Amount</p>
                        <p className="alg-l">₹{details.amount?.toFixed(2) || 'N/A'}</p>
                    </div>
                    <div className="col-md-6">
                        <p className="sd-p">Status</p>
                        <span
                            style={{
                                display: "iRejectnline-block",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: 600,
                                backgroundColor: {
                                    "Success": "#F3E8FF",
                                    "Received": "#E6F7EC",
                                    "Deposited": "#FFF7E6",
                                    "Transferred": "#E6F0FF",
                                    "Pending": "#F3F4F6",
                                    "Reject": "#FDE2E2"
                                }[details.status] || "#F3F4F6",
                                color: {
                                    "Success": "#7C3AED",
                                    "Received": "#1E7E34",
                                    "Transferred": "#1D4ED8",
                                    "Deposited": "#D97706",
                                    "Pending": "#374151",
                                    "Reject": "#B91C1C"
                                }[details.status] || "#374151",
                            }}
                        >
                            {details.status}
                        </span>
                    </div>
                    <div className='col-md-6'>
                        <p className="sd-p">Transfered Bank</p>
                        <p className="alg-l">{details?.transaction_details?.institution_bank_name}</p>
                    </div>
                    <div className="col-md-6">
                        <p className="sd-p">Transfer To</p>
                        <p className="alg-l">{details?.transfered_to?.name || 'N/A'}</p>
                    </div>
                    {details.deposit_slip_url && details.instrument !== "UPI in Bank" && (
                        <div className="col-md-6">
                            <p className="sd-p">Deposit Slip</p>
                            <p className="alg-l">
                                <a
                                    href={details.deposit_slip_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'none', color: '#7F56DA', cursor: 'pointer' }}
                                >
                                    View Slip
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#7F56DA"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ marginLeft: '5px' }}
                                    >
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                        <polyline points="7 10 12 15 17 10" />
                                        <line x1="12" y1="15" x2="12" y2="3" />
                                    </svg>
                                </a>
                            </p>
                        </div>
                    )}

                    <div className="col-md-6">
                        <p className="sd-p">Remarks</p>
                        <p className="alg-l">{details.remarks || 'N/A'}</p>
                    </div>


                    {details.instrument === "UPI in Bank" && details.transaction_details?.upi_details && (
                        <><div className="col-md-6">
                            <p className="sd-p">Transactions Number</p>
                            <p className="alg-l">{details.transaction_details.upi_details.transaction_reference || 'N/A'}</p>
                        </div>
                            {details.transaction_details?.upi_details && (

                                <div className="col-md-6">
                                    <p className="sd-p">Deposit Slip</p>
                                    <p className="alg-l">
                                        <a
                                            href={details.transaction_details?.upi_details?.deposit_slip}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: '#7F56DA', cursor: 'pointer' }}
                                        >
                                            View Slip
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#7F56DA"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                style={{ marginLeft: '5px' }}
                                            >
                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                <polyline points="7 10 12 15 17 10" />
                                                <line x1="12" y1="15" x2="12" y2="3" />
                                            </svg>
                                        </a>
                                    </p>
                                </div>

                            )}
                        </>
                    )}
                </div>

                {/* Cheque Details - Available for both transfer and deposit types */}
                {details.instrument === "Cheque" && details.transaction_details?.cheque_details && (
                    <div className="row mt-3">
                        <p className="fw-bold">Cheque Details</p>
                        <div className="col-md-6">
                            <p className="sd-p">Cheque Number</p>
                            <p className="alg-l">{details.transaction_details.cheque_details.cheque_number || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Bank</p>
                            <p className="alg-l">{details.transaction_details.cheque_details.bank_name || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">IFSC Code</p>
                            <p className="alg-l">{details.transaction_details.cheque_details.ifsc_code || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Cheque Date</p>
                            <p className="alg-l">{details.transaction_details.cheque_details.cheque_date || 'N/A'}</p>
                        </div>
                        {/* Show cheque image for both transfer and deposit types */}
                        {details.transaction_details.cheque_details.cheque_image && (
                            <div className="col-md-6">
                                <p className="sd-p">Cheque Image</p>
                                <p className="alg-l">
                                    <a
                                        href={details.transaction_details.cheque_details.cheque_image}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: '#7F56DA', cursor: 'pointer' }}
                                    >
                                        View Image
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#7F56DA"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{ marginLeft: '5px' }}
                                        >
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    </a>
                                </p>
                            </div>
                        )}
                    </div>
                )}


                {details.instrument === "Demand Draft" && details.transaction_details?.dd_details && (
                    <div className="row mt-3">
                        <p className="fw-bold">Demand Draft Details</p>
                        <div className="col-md-6">
                            <p className="sd-p">DD Number</p>
                            <p className="alg-l">{details.transaction_details.dd_details.dd_number || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Issuing Bank</p>
                            <p className="alg-l">{details.transaction_details.dd_details.issuing_bank || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Issuing Branch</p>
                            <p className="alg-l">{details.transaction_details.dd_details.issuing_branch || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Date of Issuing</p>
                            <p className="alg-l">{details.transaction_details.dd_details.date_of_issuing || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Payee Name</p>
                            <p className="alg-l">{details.transaction_details.dd_details.payee_name || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Payable At</p>
                            <p className="alg-l">{details.transaction_details.dd_details.payable_at || 'N/A'}</p>
                        </div>
                        {/* Show DD image for both transfer and deposit types */}
                        {details.transaction_details.dd_details.dd_image && (
                            <div className="col-md-6">
                                <p className="sd-p">DD Image</p>
                                <p className="alg-l">
                                    <a
                                        href={details.transaction_details.dd_details.dd_image}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: '#7F56DA', cursor: 'pointer' }}
                                    >
                                        View Image
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#7F56DA"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{ marginLeft: '5px' }}
                                        >
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    </a>
                                </p>
                            </div>
                        )}
                    </div>
                )}

                {/* NEFT/RTGS/IMPS Details */}
                {/* {details.instrument === "NEFT/RTGS/IMPS" && details.transaction_details?.neft_rtgs_details && ( */}
                {["NEFT", "RTGS", "IMPS"].includes(details.instrument) &&(
                    <div className="row mt-3">
                        <p className="fw-bold">NEFT/RTGS/IMPS Details</p>
                        <div className="col-md-6">
                            <p className="sd-p">UTR Number</p>
                            <p className="alg-l">{details?.transaction_details?.neft_rtgs_details?.utr_number || 'N/A'}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="sd-p">Bank</p>
                            <p className="alg-l">{details?.transaction_details?.neft_rtgs_details?.institution_bank_name || 'N/A'}</p>
                        </div>
                    </div>
                )}

                {/* General Deposit Slip - Available for all payment methods */}


            </div>
        </>
    );
};
